<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Combo</h4>
      </div>
      <div>
        <!-- <div>
          <label>Vending Machine</label>
        </div>
        <el-select
          class="select-default"
          size="large"
          placeholder="Selecione"
          v-model="model.vm"
        >
          <el-option
            v-for="option in machines"
            class="select-danger"
            :value="option.id"
            :label="option.location"
            :key="option.id"
          ></el-option>
        </el-select> -->
        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="model.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input
          name="name"
          label="Nome"
          v-validate="modelValidations.name"
          v-model="model.name"
          :error="getError('name')"
        ></fg-input>

        <fg-input label="Descrição">
          <textarea
            class="form-control"
            v-model="model.description"
            placeholder="Escreva aqui..."
            rows="3"
          ></textarea>
        </fg-input>

        <!-- <fg-input label="Preço">
          <div class="row">
            <fg-input
              name="price"
              v-validate="modelValidations.price"
              v-model="model.price"
              :error="getError('price')"
              class="col-sm-12"
            >
              <span slot="addonLeft">R$</span>
            </fg-input>
          </div>
        </fg-input> -->

        <fg-input
          name="sku"
          label="SKU"
          v-validate="modelValidations.sku"
          v-model="model.sku"
          :error="getError('sku')"
        ></fg-input>

        <div>
          <label>Produtos e variações</label> 
          <el-tooltip  effect="dark" content="Caso escolha uma variação, não escolha o produto referente dessa variação." placement="top-start">
            <i style="margin-left: 10px" class="fa fa-question-circle"></i>
          </el-tooltip>
        </div>
        <el-select
          multiple
          class="select-primary"
          size="large"
          style="width: 100%"
          v-model="selectItem"
          placeholder="Escolha os produtos"
        >
          <el-option
            v-for="option in allItem"
            class="select-primary"
            :value="option.id"
            :label="'Produto  : ' + option.name"
            :key="`${option}-${option.id}`"
          ></el-option>
        </el-select>
        <!-- <el-select
          multiple
          class="select-primary"
          size="large"
          style="width: 50%; padding: 5px"
          v-model="model.variants"
          placeholder="Escolha as variações"
        >
          <el-option
            v-for="option in variants"
            class="select-primary"
            :value="option.id"
            :label="option.name + ' do produto: ' + option.product"
            :key="`${option}-${option.id}`"
          ></el-option>
        </el-select> -->
        <!-- <div v-for="p in model.products" :key="p.id">{{ p.name }} {{ p.id }}</div> -->
      </div>
      <div style="margin-top: 10px">
        <label>Imagem</label>
      </div>

      <div>
        <img v-if="model.image" :src="model.image" alt="Imagem categoria" style="padding: 15px" height="100%">
      </div>

        <l-button
          v-if="!model.image"
          style="margin-left: 25px"
          size="sm"
          class="btn btn-social btn-round btn-outline btn-info"
          @click="$refs.SelectImage.click()"
        >Nova imagem</l-button>
        <l-button
          v-if="model.image"
          style="margin-left: 25px"
          size="sm"
          class="btn btn-social btn-round btn-outline btn-info"
          @click="$refs.SelectImage.click()"
        >Trocar imagem</l-button>
        <!-- <l-button
          v-if="model.image"
          style="margin-left: 25px"
          size="sm"
          class="btn btn-social btn-round btn-outline btn-info"
          @click="delImage()"
        >Excluir imagem</l-button> -->
        <input
          name="image"
          style="display: none"
          label="Image"
          type="file"
          ref="SelectImage"
          accept="image/*"
          @change="onChange"
          class="col-sm-12"
        >
    </card>

    <!-- PREÇOS POR VM -->
    <card v-if="showPrices">
      <div slot="header">
        <h5 class="card-title">Preço por Vending Machine e Lockers</h5>
      </div>
      <div v-if="vms"> 
        <div>
          <label style="margin-bottom: 15px">Vending Machines</label>
        </div>
        <div v-for="vm in vms" :key="vm.index" style="margin-left: 15px" class="row">
          <div class="col-sm-2"> 
            <span style="size: 0.4rem">{{vm.location}}</span>
          </div>
          <div class="col-sm-6">
            <fg-input >
              <fg-input
                name="price"
                @blur="putPrice(vm)"
                v-validate="modelValidations.price"
                v-model="pricesVM[vm.id]"
                :error="getError('price')"
                class="col-sm-5"
              >
                <span slot="addonLeft">R$</span>
              </fg-input>
            </fg-input>
          </div>
        </div>
      </div>
      <div v-if="lockers.length > 0">
        <div>
          <label style="margin-bottom: 15px">Lockers</label>
        </div>
        <div v-for="lock in lockers" :key="lock.index" style="margin-left: 15px" class="row">
          <div class="col-sm-2"> 
            <span style="size: 0.4rem">{{lock.location}}</span>
          </div>
          <div class="col-sm-6">
            <fg-input >
              <fg-input
                name="price"
                @blur="putPrice(lock)"
                v-validate="modelValidations.price"
                v-model="pricesVM[lock.id]"
                :error="getError('price')"
                class="col-sm-5"
              >
                <span slot="addonLeft">R$</span>
              </fg-input>
            </fg-input>
          </div>
        </div>
      </div>
    </card>
    <card>
      <div>
        <el-button type="primary" :loading="btnLoading" 
          @click.prevent="validate">Salvar</el-button>
        <!-- <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button> -->
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, Loading, Button, Tooltip } from "element-ui";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
  },
  created() {
    this.machines = this.$store.state.machines.machines
    // this.$store.dispatch("machines/list").then(resp => {
    //   this.machines = resp
    //   console.log('mach', this.machines)
    // })
    var ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      console.log('ciaID', ciaID)
      this.ciaID = ciaID
    } else {
      ciaID = this.$store.state.auth.company
      this.ciaID = ciaID
    }
    
    this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID}).then(resp => {
      this.$store.dispatch("products/variants/listSort",{sort: '?company=' + ciaID}).then( data =>{
        this.variants = data
        for (let index = 0; index < data.length; index++) {
          this.variants[index].name  = data[index].product_name +' - Variação : ' + data[index].name
          this.variants[index].id  = 'a' + data[index].id
        }
        this.allItem = resp.concat(this.variants)
        this.allItem = this.allItem.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
        console.log('all', this.allItem)
      })
        if (this.$route.params.id) {
          this.$store.dispatch("combos/get", {id: this.$route.params.id}).then(data => {
            console.log('getcombo', data.variants.length) 
            this.model = data
            var newId = []
            for (let index = 0; index <  data.variants.length; index++) {
              newId[index] = 'a' + data.variants[index]
            }
            this.selectItem = newId.concat(data.products)
          });
          this.crud = "Editar";
        } else {
          this.crud = "Criar";
        }
    });
  },
  mounted () {
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.getVm(ciaID)
    } else { 
      this.getVm()
    }
    this.$watch('model.company',()=>{
      this.vms = []
      this.lockers = []
      this.$store.dispatch('general/flag', {id: this.model.company}).then(()=>{
        this.getData()
        this.getVm(this.model.company)
      })
    })
    this.getListCompany()
  },
  computed: {
    allProducts() {
      return this.$store.state.products.products;
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach == 'true') {
        return true
      } else {
        return false
      }
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  data() {
    return {
      crud: "Editar",
      dialogImageUrl: "",
      dialogVisible: false,
      btnLoading: false,
      showPrices: false,
      finalPrice: [],
      pricesVM: [],
      selectItem: [],
      companyList: [],
      allItem: [],
      imageKey: 0,
      vms: [],
      lockers: [],
      machines: [],
      variants: [],
      changeImage: false,
      ciaID: '',
      images: [],
      model: {
        vm: null,
        image: '',
        name: "",
        price: "",
        sku: "",
        description: "",
        products: [],
        variants: []
      },
      modelValidations: {
        name: {
          required: true
        },
        sku: {
          required: true
        },
        price: {
          required: true,
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        }
      }
    };
  },
  methods: {
    onChange(event) {
      for (let i of event.target.files) {
        const reader = new FileReader();
        reader.onload = e => {
          const image = e.target.result;
          this.model.image = image
        };
        console.log("i", i);
        this.hasImage = true;
        reader.readAsDataURL(i);
      }
      this.changeImage = true
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    getData () {
      this.$store.dispatch("products/listSort",{sort: '?company=' + this.model.company}).then(resp => {
        this.$store.dispatch("products/variants/listSort",{sort: '?company=' + this.model.company}).then( data =>{
          this.variants = data
          for (let index = 0; index < data.length; index++) {
            this.variants[index].name  = data[index].product_name +' - Variação : ' + data[index].name
            this.variants[index].id  = 'a' + data[index].id
          }
          this.allItem = resp.concat(this.variants)
          this.allItem = this.allItem.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
          console.log('all', this.allItem)
        })
      });
    },
    delImage () {
      this.model.image = ''
      this.changeImage = true
    },
    parseCommaFloat(stringValue) {
      stringValue = stringValue.trim();
      let result = stringValue.replace(/[^0-9]/g, "");
      if (/[,\.]\d{2}$/.test(stringValue)) {
        result = result.replace(/(\d{2})$/, ".$1");
      }
      return parseFloat(result);
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    getVm (id) {
      if (id) { 
        id = id
      } else {
        id = ''
      }
      console.log('store',this.$store.state.general)
      this.$store.dispatch('machines/get', {id: '?company=' + id}).then(resp => {
        // this.vms = resp

        var y = this.$store.state.general.flag.filter(el => {
          if (el.feature === "V03"){
            console.log('V03')
            if (el.active === true) {
              console.log('ativo')
              return el
            }
          }
        })
        var x = []
        this.vms = resp.map(el =>{
          return y.filter(ar =>{
            if (ar.vm == el.id) {
              x.push(el)
            }
          })

        })
        this.vms = x
        console.log('vms', this.vms)
      })
      this.$store.dispatch('lockers/listSort', {sort: '?company=' + id}).then(resp => {

        var f = this.$store.state.general.flag.filter(el => {
          if (el.feature === "V03"){
            if (el.active === true) {
              return el
            }
          }
        })
        var z = []
        this.lockers = resp.map(el =>{
          return f.filter(ar =>{
            if (ar.vm == el.id) {
              z.push(el)
            }
          })

        })
        this.lockers = z
        this.showPrices = true
      })
      if (this.$route.params.id) {
        this.$store.dispatch('vmPrice/listSortCombo', {sort: '?combo=' + this.$route.params.id + '&page_size=50' }).then(data =>{
          // this.finalPrice = data
          for (let index = 0; index < data.length; index++) {
            // if (data[index].product_variant === null) {
              this.finalPrice[data[index].id] = data[index]  
              this.pricesVM[data[index].vm] = data[index].price  
            // }
          }
          console.log('finalPrice', this.finalPrice)
          console.log('pricesVM', this.pricesVM)
        })
      }
    },
    putPrice (data) {
      console.log('data', data)
      console.log('vms', this.vms)
      console.log('lock', this.lockers)
      console.log('antes', this.finalPrice)
      console.log('leng', this.finalPrice.length)

      var juntos
      juntos = this.vms.concat(this.lockers)
      console.log('juntos', juntos)

      
      if (this.crud === "Criar"){
        if (this.showMatriz) {
          this.finalPrice[data.id] =  {
            vm: data.id,
            price: this.pricesVM[data.id].replace(",", "."),
            combo: '',
            company: this.model.company
          }
        } else {
          this.finalPrice[data.id] =  {
            vm: data.id,
            price: this.pricesVM[data.id].replace(",", "."),
            combo: '',
            company: this.ciaID
          }
        }
      }
      if (this.crud === "Editar") {
        var exist = this.finalPrice.filter(v => {
          return v.vm === data.id
        })
        if (exist.length === 0) {
          this.finalPrice[data.id] =  {
            vm: data.id,
            price: this.pricesVM[data.id].replace(",", "."),
            combo: this.$route.params.id,
            company: this.model.company
          }
        }
        this.finalPrice.forEach(v => {
            if (v.vm === data.id) {
              v.price = this.pricesVM[data.id].replace(",", ".")
            }
        })
      }
      console.log('final do price', this.finalPrice)
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    notifyError() {
      this.$notify({
        message: "Erro!</br>Item não salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
      this.btnLoading = false
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.model.vm = null
        this.model.price = 0.01
        if (!this.showMatriz) {
          this.model.company = this.ciaID
        }
        this.btnLoading = true
        this.model.products = []
        this.model.variants = []
        // para apenas um select de produtos:
        for (let i = 0; i < this.selectItem.length; i++) {
          if (typeof this.selectItem[i] === 'string') {
            this.model.variants.push(this.selectItem[i].replace("a", ""))
          }
          if (typeof this.selectItem[i] === 'number') {
            this.model.products.push(this.selectItem[i])
          }
        }

        console.log('model', this.model)
        const newModel = { ...this.model };
        // newModel.price = this.parseCommaFloat(this.model.price);
        if (!this.changeImage) {
          console.log('enotrudh', newModel)
          delete newModel.image
        }

        if (isValid && this.crud === "Criar") {
          this.$store.dispatch("combos/create", { item: newModel }).then(data => {
        if (data.id === undefined) {
          this.notifyError()
        } else {
          for (let index = 0; index < this.finalPrice.length; index++) {
            if (this.finalPrice[index] !== undefined) {
              this.finalPrice[index].combo = data.id
              this.$store.dispatch('vmPrice/createCombo', {item: this.finalPrice[index]})
            }
          }
        }
        this.btnLoading = false
        this.notifySuccess();
        this.$router.push(`/app/machines/combos`);
          });
        } else if (isValid && this.crud === "Editar") {
          // if (!this.changeImage) {
          //   console.log('enotrudh', newModel)
          //   delete newModel.image
          // }
          this.$store.dispatch("combos/update", { item: newModel }).then(data => {
            for (let index = 0; index < this.finalPrice.length; index++) {
              if (this.finalPrice[index] !== undefined) {
                if (this.finalPrice[index].id === undefined) {
                  this.finalPrice[index].combo = this.$route.params.id
                  this.$store.dispatch('vmPrice/createCombo', {item: this.finalPrice[index]}).then(resp=>{
                    console.log('criou quando deu indefinido', resp)
                  })
                } else {
                  this.finalPrice[index].combo = data.id
                  this.$store.dispatch('vmPrice/updateCombo', {item: this.finalPrice[index]})
                }
              }
            }
            this.notifySuccess();
            this.btnLoading = false
            this.$router.push(`/app/machines/combos`);
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
/* img {
  width: 200px;
} */
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
img {
  width: 200px;
}
</style>
